import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import React, { useEffect, useRef } from 'react';
import lottie from 'lottie-web';
import TvingSpinner from '@tving/utils/src/utils/tving-spinner/TvingSpinner';
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import animationData from './animationData.json';
import StyledSplashLayer from './SplashLayer.style';
/**
 * 스플래시 표출 관련 레이어
 */
var SplashLayer = function (_a) {
    var setIsSplashPlayComplete = _a.setIsSplashPlayComplete;
    var divRef = useRef(null);
    useEffect(function () {
        var handleComplete = function () {
            setIsSplashPlayComplete(true);
        };
        var splash = lottie.loadAnimation({
            container: divRef.current,
            renderer: 'svg',
            loop: false,
            autoplay: false,
            animationData: JSON.parse(JSON.stringify(animationData)),
        });
        if (splash) {
            splash.addEventListener('complete', handleComplete);
        }
        setTimeout(function () {
            void (splash === null || splash === void 0 ? void 0 : splash.play());
        }, 100);
        return function () {
            if (splash) {
                splash.removeEventListener('complete', handleComplete);
                splash.stop();
                splash.destroy();
                lottie.stop();
                lottie.destroy();
            }
        };
    }, [setIsSplashPlayComplete]);
    return (_jsxs(StyledSplashLayer, { children: [_jsx("div", { ref: divRef }), _jsx(TvingSpinner, { delay: 2000 })] }));
};
export default SplashLayer;
